<template>
    <Card>
        <AllowPermission :permission="PERMISSION_CODES.CMS_VIEW_STOCK_UPDATE_LOG">
            <div>
                <div>
                    <form class="" style="gap: 10px; max-width: 350px">
                        <!--<div class="d-flex align-items-end" style="gap: 10px">
                        <div class="">
                            <p class="my-2">Start Date*</p>
                            <div>
                                <input
                                    class="form-control form-control-sm"
                                    type="date"
                                    :id="`form-year`"
                                    :max="maxStartDate"
                                    v-model="startDate"
                                />
                            </div>
                        </div>
                        <div class="">
                            <p class="my-2">End Date*</p>
                            <div>
                                <input
                                    type="date"
                                    class="form-control form-control-sm"
                                    :id="`form-year`"
                                    :min="minEndDate"
                                    :max="maxEndDate"
                                    v-model="endDate"
                                />
                            </div>
                        </div>
                    </div> -->
                        <div class="my-3">
                            <p class="my-2">Select event code</p>
                            <SelectDropdown
                                v-if="eventCodes.length"
                                :id="`form-month`"
                                :options="eventCodes"
                                :value="selectedEventCode"
                                @change="selectedEventCode = $event"
                            />
                        </div>
                        <div class="d-flex" style="gap: 10px">
                            <Button style="background-color: #e93c2f" :noMargin="true" type="button" @click="fetchData(true)">{{
                                loading ? "Please wait..." : "Clear Filters"
                            }}</Button>
                            <Button type="button" :noMargin="true" @click="fetchData">{{
                                loading ? "Please wait..." : "Load Data"
                            }}</Button>
                        </div>
                    </form>
                </div>
                <UiState v-if="loading" type="loading" title="Loading stock logs" compact />
                <UiState
                    v-else-if="loadError"
                    type="error"
                    title="Could not load stock logs"
                    :message="loadError"
                    action-label="Retry"
                    compact
                    @action="fetchData"
                />
                <UiState v-else-if="logs.length == 0" type="empty" title="No stock logs found" compact />
                <CustomTable v-else>
                    <template #head>
                        <tr>
                            <th>Sr No</th>
                            <th>Item</th>
                            <th>Event</th>
                            <th>Warehouse</th>
                            <th>Qty</th>
                            <th>Backroom Qty</th>
                            <th>Timestamp</th>
                        </tr>
                    </template>
                    <template #body>
                        <tr v-for="log of logs" :key="log.id">
                            <td>{{ log.srNo }}</td>
                            <td>{{ sliceText(log.item_name, 40) }}</td>
                            <td>
                                <template v-if="buildEventLink(log)">
                                    <router-link :to="buildEventLink(log)">
                                        {{ log.eventName }}
                                        {{ log.qtyAdjustmentReasonCode ? `(${log.qtyAdjustmentReasonCode})` : "" }}
                                    </router-link>
                                </template>
                                <template v-else>
                                    {{ log.eventName }}
                                    {{ log.qtyAdjustmentReasonCode ? `(${log.qtyAdjustmentReasonCode})` : "" }}
                                </template>
                            </td>
                            <td>{{ log.warehouse_name }}</td>
                            <td>{{ log.qty > 0 ? (log.isAddition ? "+" : "-") : "" }}{{ log.qty }}</td>
                            <td>{{ log.backRoomQty > 0 ? (log.isAddition ? "+" : "-") : "" }}{{ log.backRoomQty }}</td>
                            <td>{{ log.createdAtEstFormatted }}</td>
                        </tr>
                    </template>
                </CustomTable>
            </div>
            <Paginator :totalPages="totalPages" :page="page" @change="page = $event" />
        </AllowPermission>
    </Card>
</template>

<script>
import { mapActions } from "vuex"
import CustomTable from "../../components/layout/CustomTable.vue"
import { http } from "../../utils/http"
import Card from "../../components/UI/Card.vue"
import Paginator from "../../components/other/Paginator.vue"
import Button from "../../components/UI/Button.vue"
import { sliceText, usDateFormat } from "../../utils/common"
import { mapState } from "vuex"
import SelectDropdown from "../../components/crud/SelectDropdown.vue"
import AllowPermission from "../../components/layout/AllowPermission.vue"
import { PERMISSION_CODES } from "../../store/permission"
import UiState from "../../components/UI/UiState.vue"
import { inventoryAdjustmentQuantityPath, purchaseOrderDetailPath, stockTransferDetailPath } from "../../router/route-paths"

export default {
    data() {
        return {
            logs: [],
            totalPages: 0,
            page: 1,
            loading: true,
            limit: 10,
            startDate: "",
            endDate: "",
            eventCodes: [],
            selectedEventCode: "",
            loadError: "",
            PERMISSION_CODES,
        }
    },
    components: {
        SelectDropdown,
        Button,
        Paginator,
        Card,
        CustomTable,
        AllowPermission,
        UiState,
    },
    mounted() {
        this.setData({
            pageTitle: "Stock Adjustment Logs",
        })
        this.fetchEventCodes()
        this.fetchData()
    },
    computed: {
        ...mapState("misc", ["itemGroups", "warehouses"]),
        maxStartDate() {
            const today = new Date()
            const maxStDate = !this.endDate || today < new Date(this.endDate) ? today : this.endDate || null
            console.log("maxStDate", maxStDate)
            return new Date(maxStDate).toISOString().slice(0, 10)
        },
        minEndDate() {
            if (this.showStartDate) {
                const minEnd = this.startDate ? new Date(this.startDate).toISOString().slice(0, 10) : null
                return minEnd
            }
            return null
        },
        maxEndDate() {
            return new Date().toISOString().slice(0, 10)
        },
    },
    methods: {
        sliceText,
        usDateFormat,
        ...mapActions("misc", ["setData"]),
        initDates() {
            // Initialize to a broad default range (last 180 days) to ensure results appear
            const end = new Date()
            const start = new Date()
            start.setDate(start.getDate() - 180)
            this.startDate = start.toISOString().slice(0, 10)
            this.endDate = end.toISOString().slice(0, 10)
        },
        async fetchEventCodes() {
            try {
                this.eventCodes = []
                const res = await http.get(`/stock/logs/event-codes`)
                this.eventCodes = [
                    { id: "", title: "All" },
                    ...Object.values(res.data.result)
                        .filter((item) => item.code !== 'SALE')
                        .map((item) => ({ id: item.code, title: item.name })),
                ]
                this.totalPages = res.data.totalPages
            } catch (err) {
                console.log("error in fetching stock log event codes", err)
            }
        },
        async fetchData(clearFilters = false) {
            try {
                if (clearFilters) {
                    this.initDates()
                    this.selectedEventCode = ""
                    this.page = 1
                }
                this.loading = true
                this.loadError = ""
                this.logs = []
                const res = await http.get("/stock/logs", {
                    params: {
                        page: this.page,
                        limit: this.limit,
                        event_code: this.selectedEventCode,
                        start_date: this.startDate,
                        end_date: this.endDate,
                    },
                })
                this.logs = res.data.result
                this.totalPages = res.data.totalPages
            } catch (err) {
                console.log("error in fetching stock logs", err)
                this.loadError = "Try adjusting filters or retrying the request."
            }
            this.loading = false
        },
        buildEventLink(log) {
            // Build route based on ref_type/ref_id/ref_name (graceful fallback if absent)
            if (!log || !log.ref_type) return null
            if (log.ref_type === 'PURCHASE_ORDER' && log.ref_id) return purchaseOrderDetailPath(log.ref_id)
            if (log.ref_type === 'STOCK_TRANSFER' && log.ref_id) return stockTransferDetailPath(log.ref_id)
            if (log.ref_type === 'QTY_ADJUSTMENT' && (log.ref_name || log.ref_id)) return inventoryAdjustmentQuantityPath(log.ref_name || log.ref_id)
            return null
        },
    },
    watch: {
        page(e) {
            this.fetchData()
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

form {
  gap: $sectionGap;
}

/* Align numeric columns */
::deep(table) {
  thead th:nth-child(5),
  thead th:nth-child(6) {
    text-align: right;
  }
  tbody td:nth-child(5),
  tbody td:nth-child(6) {
    text-align: right;
  }
}
</style>
